webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(125);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(119);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ngraph = __webpack_require__(47);
	
	var _ngraph2 = _interopRequireDefault(_ngraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bus = (0, _ngraph2.default)({});
	
	exports.default = bus;

/***/ },
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(66);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _queryState = __webpack_require__(49);
	
	var _queryState2 = _interopRequireDefault(_queryState);
	
	var _LanguageCollection = __webpack_require__(53);
	
	var _LanguageCollection2 = _interopRequireDefault(_LanguageCollection);
	
	var _createSideBarState = __webpack_require__(54);
	
	var _createSideBarState2 = _interopRequireDefault(_createSideBarState);
	
	var _bus = __webpack_require__(17);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _formatNumber = __webpack_require__(29);
	
	var _formatNumber2 = _interopRequireDefault(_formatNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var qs = _queryState2.default.instance({
	  lang: 'js'
	});
	
	var languages = new _LanguageCollection2.default();
	languages.add('js', 'JavaScript');
	languages.add('jsx', 'React');
	languages.add('css', 'Cascading Style Sheets');
	languages.add('html', 'HTML');
	languages.add('java', 'Java');
	languages.add('py', 'Python');
	languages.add('lua', 'Lua');
	languages.add('php', 'PHP');
	languages.add('rb', 'Ruby');
	languages.add('cpp', 'C++', '.C, .cc, .cpp, .c++, .cp, .cxx, .h');
	languages.add('pl', 'Perl', '.pm');
	languages.add('cs', 'C#');
	languages.add('scala', 'Scala');
	languages.add('go', 'Go');
	languages.add('sql', 'SQL');
	languages.add('rs', 'Rust');
	languages.add('lisp', 'Lisp', '.lsp, .lisp');
	languages.add('clj', 'Clojure', '.clj, .cljs');
	languages.add('kt', 'Kotlin', '.kt, .ktm, .kts');
	languages.add('cmake', 'CMake', '.cmake, .cmake.in');
	languages.add('swift', 'Swift');
	languages.add('hs', 'Haskell', '.hs, .hsc');
	languages.add('ex', 'Elixir', '.ex, .exs');
	languages.add('objc', 'Objective C/C++', '.m, .mm');
	languages.add('fs', 'F#', '.fs, .fsi');
	languages.add('elm', 'Elm', '.elm');
	languages.add('purs', 'PureScript', '.purs');
	languages.add('pas', 'Pascal', '.pas');
	languages.add('r', 'R', '.R');
	languages.add('erl', 'Erlang', '.erl');
	languages.add('vim', 'VimL', '.vim');
	languages.add('groovy', 'Groovy', '.groovy');
	languages.select(qs.get('lang'));
	
	qs.onChange(function () {
	  languages.select(qs.get('lang'));
	});
	
	function updateSelected(newLanguage) {
	  appState.sideBar.close();
	  languages.select(newLanguage);
	  qs.set('lang', languages.selected);
	}
	
	function selectWord(word) {
	  appState.sideBar.showContext(word);
	}
	
	var appState = {
	  languages: languages,
	  listState: {
	    expanded: false
	  },
	  allWords: [],
	  sideBar: (0, _createSideBarState2.default)(languages),
	  updateSelected: updateSelected,
	  selectWord: selectWord
	};
	
	exports.default = appState;
	
	
	_bus2.default.on('context-changed', function (context) {
	  appState.allWords = (0, _keys2.default)(context).map(function (key) {
	    return context[key];
	  }).sort(function (x, y) {
	    return y.total - x.total;
	  }).map(function (value, idx) {
	    return {
	      place: idx,
	      text: value.word,
	      total: (0, _formatNumber2.default)(value.total)
	    };
	  });
	});

/***/ },
/* 29 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatNumber;
	
	
	function formatNumber(number) {
	  return number.toString(10).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	}

/***/ },
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(62);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _map = __webpack_require__(63);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _create = __webpack_require__(64);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _classCallCheck2 = __webpack_require__(30);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(31);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _bluebird = __webpack_require__(32);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _request = __webpack_require__(57);
	
	var _request2 = _interopRequireDefault(_request);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = 'static/data';
	
	var Language = function () {
	  function Language(extension, text, displayExtensions) {
	    (0, _classCallCheck3.default)(this, Language);
	
	    this.extension = extension;
	    var display = displayExtensions || '.' + extension;
	    this.text = text + ' - ' + display;
	    this.positions = null;
	  }
	
	  (0, _createClass3.default)(Language, [{
	    key: 'markSelected',
	    value: function markSelected(isSelected) {
	      this.selected = isSelected;
	    }
	  }, {
	    key: 'getLinesWithWord',
	    value: function getLinesWithWord(word) {
	      var _this = this;
	
	      if (!this.context) {
	        var resolveLater = new _bluebird2.default(function (resolve) {
	          _this.pendingWordContext = { resolve: resolve, word: word };
	        });
	        return resolveLater;
	      }
	
	      return this.buildLinesWithWord(word);
	    }
	  }, {
	    key: 'loadPositions',
	    value: function loadPositions() {
	      var _this2 = this;
	
	      if (this.positions) {
	        return _bluebird2.default.resolve(this.positions);
	      }
	
	      var prefix = path + '/' + this.extension;
	      var positionsDownloadPromise = (0, _request2.default)(prefix + '/index.json').then(function (positions) {
	        _this2.positions = positions;
	        return positions;
	      });
	
	      return positionsDownloadPromise;
	    }
	  }, {
	    key: 'loadContext',
	    value: function loadContext() {
	      var _this3 = this;
	
	      if (this.context) {
	        return _bluebird2.default.resolve(this.context);
	      }
	
	      var prefix = path + '/' + this.extension;
	      return (0, _request2.default)(prefix + '/context.json').then(function (ctx) {
	        _this3.context = makeContext(ctx);
	
	        if (_this3.pendingWordContext) {
	          _this3.buildLinesWithWord(_this3.pendingWordContext.word).then(function (lines) {
	            _this3.pendingWordContext.resolve(lines);
	            _this3.pendingWordContext = null;
	          });
	        }
	
	        return _this3.context;
	      });
	    }
	  }, {
	    key: 'buildLinesWithWord',
	    value: function buildLinesWithWord(word) {
	      if (!this.context) throw new Error('You are not supposed to call this function directly. use getLinesWithWord() instead');
	
	      var wordContext = this.context[word];
	      if (!wordContext) throw new Error(word + ' is not part of the ' + this.extension + '. How did you get here?');
	
	      return _bluebird2.default.resolve(wordContext);
	    }
	  }]);
	  return Language;
	}();
	
	exports.default = Language;
	
	
	function makeContext(arrayOfWords) {
	  var context = (0, _create2.default)(null);
	  arrayOfWords.forEach(function (word) {
	    var lines = groupSameLines(word.context);
	    context[word.word] = {
	      lines: lines,
	      word: word.word,
	      total: word.useCount
	    };
	  });
	
	  return context;
	}
	
	function groupSameLines(contextLines) {
	  var uniqueLines = new _map2.default();
	  contextLines.forEach(function (contextLine) {
	    var line = contextLine[0];
	    uniqueLines.set(line, (uniqueLines.get(line) || 0) + contextLine[1]);
	  });
	  return (0, _from2.default)(uniqueLines);
	}

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(30);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(31);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Language = __webpack_require__(52);
	
	var _Language2 = _interopRequireDefault(_Language);
	
	var _bus = __webpack_require__(17);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LanguageCollection = function () {
	  function LanguageCollection() {
	    (0, _classCallCheck3.default)(this, LanguageCollection);
	
	    this.known = {};
	    this.list = [];
	    this.selected = '';
	  }
	
	  (0, _createClass3.default)(LanguageCollection, [{
	    key: 'add',
	    value: function add(extension, text, displayExtensions) {
	      if (this.known[extension] !== undefined) throw new Error('Extension is already registered');
	
	      this.known[extension] = this.list.length;
	      this.list.push(new _Language2.default(extension, text, displayExtensions));
	    }
	  }, {
	    key: 'select',
	    value: function select(extension) {
	      var currentSelected = this.getLanguageByExtension(this.selected);
	      if (currentSelected) currentSelected.markSelected(false);
	
	      var newSelected = this.getLanguageByExtension(extension);
	      if (!newSelected) throw new Error('unknown langauge ' + extension);
	
	      this.selected = extension;
	      _bus2.default.fire('loading');
	      newSelected.loadPositions().then(function (positions) {
	        _bus2.default.fire('loaded', positions);
	      });
	      newSelected.loadContext().then(function (context) {
	        _bus2.default.fire('context-changed', context);
	      });
	    }
	  }, {
	    key: 'getLanguageByExtension',
	    value: function getLanguageByExtension(extension) {
	      var languageIndex = this.known[extension];
	      return this.list[languageIndex];
	    }
	  }]);
	  return LanguageCollection;
	}();
	
	exports.default = LanguageCollection;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSideBarState;
	
	var _formatNumber = __webpack_require__(29);
	
	var _formatNumber2 = _interopRequireDefault(_formatNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createSideBarState(languages) {
	  var state = {
	    show: false,
	    header: '',
	    word: '',
	    showContext: showContext,
	    close: close
	  };
	
	  return state;
	
	  function close() {
	    state.show = false;
	  }
	
	  function showContext(word) {
	    var language = languages.getLanguageByExtension(languages.selected);
	    if (!language) throw new Error('How come there is no selected language?');
	
	    language.getLinesWithWord(word).then(function (context) {
	      state.show = true;
	      state.lines = context.lines.map(function (line) {
	        return toLineViewModel(line, word);
	      });
	      state.header = context.word + '  - ' + (0, _formatNumber2.default)(context.total);
	    });
	  }
	}
	
	function toLineViewModel(line, word) {
	  var stopWord = new RegExp('\\b' + word + '\\b');
	  var words = line[0].split(stopWord).map(function (text) {
	    return {
	      text: text,
	      bold: false
	    };
	  });
	
	  var parts = [];
	  for (var i = 0; i < words.length - 1; ++i) {
	    parts.push(words[i], {
	      text: word,
	      bold: true
	    });
	  }
	  parts.push(words[words.length - 1]);
	
	  var count = (0, _formatNumber2.default)(line[1]);
	
	  return {
	    text: line[0],
	    count: count,
	    parts: parts
	  };
	}

/***/ },
/* 55 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clap;
	var maxSingleTouchTime = 300;
	var singleTapDistanceSquared = 25;function clap(el, fn) {
	  var touchStartTime = void 0;
	  var startPos = { x: 0, y: 0 };
	
	  if (typeof fn === 'function') {
	    el.addEventListener('mousedown', handleMouseDown);
	    el.addEventListener('mouseup', handleMouseUp);
	
	    el.addEventListener('touchend', handleTouchEnd);
	    el.addEventListener('touchstart', handleTouchStart);
	  }
	
	  return dispose;
	
	  function handleMouseDown(e) {
	    touchStartTime = new Date();
	    startPos.x = e.pageX;
	    startPos.y = e.pageY;
	  }
	
	  function handleMouseUp(e) {
	    invokeHandleForPoint(e, e);
	  }
	
	  function handleTouchStart(e) {
	    var touches = e.touches;
	
	    if (touches.length === 1) {
	      touchStartTime = new Date();
	      startPos.x = e.touches[0].pageX;
	      startPos.y = e.touches[0].pageY;
	    }
	  }
	
	  function handleTouchEnd(e) {
	    if (e.touches.length > 1) return;
	
	    invokeHandleForPoint(e.changedTouches[0], e);
	  }
	
	  function invokeHandleForPoint(pagePoint, e) {
	    var dt = new Date() - touchStartTime;
	
	    if (dt > maxSingleTouchTime) return;
	
	    var dx = pagePoint.pageX - startPos.x;
	    var dy = pagePoint.pageY - startPos.y;
	
	    if (dx * dx + dy * dy < singleTapDistanceSquared) {
	      invokeHandler(e);
	    }
	  }
	
	  function dispose() {
	    el.removeEventListener('mousedown', handleMouseDown);
	    el.removeEventListener('mouseup', handleMouseUp);
	
	    el.removeEventListener('touchend', handleTouchEnd);
	    el.removeEventListener('touchstart', handleTouchStart);
	  }
	
	  function invokeHandler(e) {
	    fn(e);
	  }
	}

/***/ },
/* 56 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var themes = {
	  coffee: {
	    text: ['#3C3A40', '#817463', '#8a3c18', '#B9424D', '#310E17'],
	    back: '#f6f9ff'
	  },
	  brownee: {
	    text: ['#98a8b8', '#4a5364', '#8a3c18', '#30140b', '#0a0909'],
	    back: '#f6f9ff'
	  },
	  lavender: {
	    text: ['#1b1341', '#3a417a', '#3d57b1', '#abb2e1', '#d3d5f2'],
	    back: 'white'
	  },
	  darkspring: {
	    text: ['#0e4675', '#9ae1d4', '#f9d4db', '#ff9690', '#f9545b'],
	    back: '#111'
	  },
	  autumn: {
	    text: ['#3f2d3b', '#743042', '#9c1f2d', '#dd800b', '#fab509'],
	    back: 'white'
	  },
	  molokai: {
	    text: ['#FFFFFF', '#48483E', '#FE9720', '#FA2772', '#E7DB75', '#A7E22E', '#66D9EE', '#AF81FF'],
	    back: '#252922'
	  },
	  solarized: {
	    text: ['#B58900', '#CB4B16', '#D33682', '#DC322F', '#6C71C4', '#268BD2', '#2AA198', '#859900'],
	    back: '#FDF6E3'
	  },
	  'solarized-dark': {
	    text: ['#B58900', '#CB4B16', '#D33682', '#DC322F', '#6C71C4', '#268BD2', '#2AA198', '#859900'],
	    back: '#002B36'
	  },
	  github: {
	    text: ['#795da3', '#333333', '#ed6a43', '#a71d5d', '#0086b3', '#63a35c'],
	    back: 'ffffff'
	  },
	  nova: {
	    text: ['#D32F2F', '#C2185B', '#7B1FA2', '#512DA8'],
	    back: '#fafafa'
	  },
	  uni: {
	    text: ['#000'],
	    back: 'white'
	  }
	};
	
	exports.default = themes;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bluebird = __webpack_require__(32);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function request(url, options) {
	  if (!options) options = {};
	  if (url.indexOf('.json') === url.length - 5) {
	    options.responseType = 'json';
	  }
	
	  return new _bluebird2.default(download);
	
	  function download(resolve, reject) {
	    var req = new window.XMLHttpRequest();
	
	    if (typeof options.progress === 'function') {
	      req.addEventListener('progress', updateProgress, false);
	    }
	
	    req.addEventListener('load', transferComplete, false);
	    req.addEventListener('error', transferFailed, false);
	    req.addEventListener('abort', transferCanceled, false);
	
	    req.open('GET', url);
	    if (options.responseType) {
	      req.responseType = options.responseType;
	    }
	    req.send(null);
	
	    function updateProgress(e) {
	      if (e.lengthComputable) {
	        options.progress({
	          loaded: e.loaded,
	          total: e.total,
	          percent: e.loaded / e.total
	        });
	      }
	    }
	
	    function transferComplete() {
	      if (req.status !== 200) {
	        reject('Unexpected status code ' + req.status + ' when calling ' + url);
	        return;
	      }
	      var response = req.response;
	
	      if (options.responseType === 'json' && typeof response === 'string') {
	        response = JSON.parse(response);
	      }
	
	      resolve(response);
	    }
	
	    function transferFailed() {
	      reject('Failed to download ' + url);
	    }
	
	    function transferCanceled() {
	      reject('Cancelled download of ' + url);
	    }
	  }
	}
	
	exports.default = request;

/***/ },
/* 58 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSvgHeader;
	
	
	function getSvgHeader(svgWidth, svgHeight, boundingBox) {
	  var width = boundingBox.width,
	      height = boundingBox.height;
	
	  return "<?xml version=\"1.0\" standalone=\"no\"?>\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg tabindex=\"1\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width='" + svgWidth + "' height='" + svgHeight + "' viewBox='0 0 " + width + " " + height + "'>\n<defs xmlns=\"http://www.w3.org/1999/xhtml\"><style type=\"text/css\">\n@font-face {\n  font-family: 'Abel';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Abel'), local('Abel-Regular'), url('data:font/woff2;base64,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') format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215, U+E0FF, U+EFFD, U+F000;\n}\n</style></defs>";
	}

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appState = __webpack_require__(28);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	var _WordsCloudRenderer = __webpack_require__(121);
	
	var _WordsCloudRenderer2 = _interopRequireDefault(_WordsCloudRenderer);
	
	var _DropClick = __webpack_require__(120);
	
	var _DropClick2 = _interopRequireDefault(_DropClick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    WordsCloudRenderer: _WordsCloudRenderer2.default,
	    DropClick: _DropClick2.default
	  },
	  data: function data() {
	    return _appState2.default;
	  },
	
	  methods: {
	    updateSelectedLanguage: function updateSelectedLanguage(newLanguage) {
	      _appState2.default.updateSelected(newLanguage);
	    },
	    closeContext: function closeContext() {
	      this.sideBar.close();
	    },
	    toggleList: function toggleList(e) {
	      if (e.target.nodeName === 'SELECT') return;
	
	      this.listState.expanded = !this.listState.expanded;
	    }
	  },
	  computed: {
	    isContextVisible: function isContextVisible() {
	      return this.sideBar.show;
	    }
	  }
	};

/***/ },
/* 60 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    items: {
	      default: []
	    },
	    selected: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      hover: false,
	      selectedInternal: this.selected
	    };
	  },
	
	  watch: {
	    selectedInternal: function selectedInternal() {
	      this.$emit('selected', this.selectedInternal);
	    }
	  },
	  computed: {
	    selectedName: function selectedName() {
	      return this.selected;
	    }
	  },
	  methods: {
	    getValue: function getValue(item) {
	      return item.value || item.name;
	    },
	    triggerMouseEnter: function triggerMouseEnter(isEnter) {
	      this.hover = isEnter;
	    }
	  }
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _panzoom = __webpack_require__(127);
	
	var _panzoom2 = _interopRequireDefault(_panzoom);
	
	var _rafor = __webpack_require__(114);
	
	var _rafor2 = _interopRequireDefault(_rafor);
	
	var _simplesvg = __webpack_require__(50);
	
	var _simplesvg2 = _interopRequireDefault(_simplesvg);
	
	var _queryState = __webpack_require__(49);
	
	var _bus = __webpack_require__(17);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _appState = __webpack_require__(28);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	var _colors = __webpack_require__(56);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _clap = __webpack_require__(55);
	
	var _clap2 = _interopRequireDefault(_clap);
	
	var _svgHeader = __webpack_require__(58);
	
	var _svgHeader2 = _interopRequireDefault(_svgHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var queryState = (0, _queryState.instance)();
	var random = __webpack_require__(110).random(42);
	
	exports.default = {
	  mounted: function mounted() {
	    _bus2.default.on('loading', this.clearScene, this);
	    _bus2.default.on('loaded', this.renderScene, this);
	
	    this.zoomer = (0, _panzoom2.default)(this.$refs.scene);
	    this.scene = (0, _simplesvg2.default)(this.$refs.scene);
	    this.disposeClap = (0, _clap2.default)(this.scene, this.selectText.bind(this));
	  },
	  destroyed: function destroyed() {
	    _bus2.default.off('loading', this.clearScene, this);
	    _bus2.default.off('loaded', this.renderScene, this);
	    this.zoomer.dispose();
	    this.disposeClap();
	  },
	
	
	  methods: {
	    clearScene: function clearScene() {
	      removeAllChildren(this.scene);
	    },
	    selectText: function selectText(e) {
	      if (e.target.tagName !== 'text') return;
	
	      _appState2.default.selectWord(e.target.text());
	    },
	    renderScene: function renderScene(positions) {
	      var themeName = queryState.get('theme');
	      var theme = _colors2.default[themeName] || _colors2.default.brownee;
	      document.body.style.backgroundColor = theme.back;
	      var scene = this.scene;
	
	      recenter(this.scene, this.zoomer, positions);
	
	      (0, _rafor2.default)(positions, renderWord, function () {
	        window.exportSVG = exportSVG;
	      }, {
	        probeElements: 20
	      });
	
	      function renderWord(p) {
	        var transform = 'translate(' + p.x + ', ' + p.y + ')';
	        if (p.rotate) transform += ' rotate(-90)';
	
	        var text = (0, _simplesvg2.default)('text', {
	          transform: transform,
	          x: p.dx,
	          'font-size': p.fontSize,
	          'font-family': p.fontFamily,
	          'dominant-baseline': 'text-before-edge',
	          fill: randomFromArray(theme.text)
	        });
	        text.text(p.text);
	
	        scene.appendChild(text);
	      }
	
	      function exportSVG(width, height) {
	        var boundingBox = scene.getBoundingClientRect();
	        var scale = scene.transform.baseVal[0].matrix.a;
	        var svgText = (0, _svgHeader2.default)(width || 1540, height || 1540, {
	          width: boundingBox.width / scale,
	          height: boundingBox.height / scale
	        }) + '<g>' + scene.innerHTML + '</g></svg>';
	        download(svgText, queryState.get('lang') + '.svg');
	      }
	    }
	  }
	};
	
	
	function download(svgText, name) {
	  var uri = 'data:image/svg+xml;base64,' + window.btoa(window.unescape(window.encodeURIComponent(svgText)));
	  var saveLink = document.createElement('a');
	  var downloadSupported = 'download' in saveLink;
	  if (downloadSupported) {
	    saveLink.download = name;
	    saveLink.href = uri;
	    saveLink.style.display = 'none';
	    document.body.appendChild(saveLink);
	    saveLink.click();
	    document.body.removeChild(saveLink);
	  } else {
	    window.open(uri, '_temp', 'menubar=no,toolbar=no,status=no');
	  }
	}
	
	function recenter(scene, zoomer, positions) {
	  var maxX = 0;
	  var maxY = 0;
	
	  positions.forEach(function (p) {
	    if (p.x > maxX) maxX = p.x;
	    if (p.y > maxY) maxY = p.y;
	  });
	
	  scaleToFit(scene.ownerSVGElement.parentNode, zoomer, maxX, maxY);
	}
	
	function scaleToFit(container, zoomer, sceneWidth, sceneHeight) {
	  var xScale = container.clientWidth / sceneWidth;
	  var yScale = container.clientHeight / sceneHeight;
	  var uniformScale = Math.min(xScale, yScale);
	  zoomer.zoomAbs(0, 0, uniformScale);
	
	  var dx = (container.clientWidth - sceneWidth * uniformScale) / 2;
	  var dy = (container.clientHeight - sceneHeight * uniformScale) / 2;
	  zoomer.moveTo(dx, dy);
	}
	
	function randomFromArray(array) {
	  return array[random.next(array.length)];
	}
	
	function removeAllChildren(node) {
	  if ('innerHTML' in node) {
	    node.innerHTML = '';
	  } else {
	    while (node.hasChildNodes()) {
	      node.removeChild(node.lastChild);
	    }
	  }
	}

/***/ },
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 108 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 109 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(109)
	
	/* script */
	__vue_exports__ = __webpack_require__(59)
	
	/* template */
	var __vue_template__ = __webpack_require__(124)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(108)
	
	/* script */
	__vue_exports__ = __webpack_require__(60)
	
	/* template */
	var __vue_template__ = __webpack_require__(123)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(107)
	
	/* script */
	__vue_exports__ = __webpack_require__(61)
	
	/* template */
	var __vue_template__ = __webpack_require__(122)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "scene-container"
	  }, [_c('svg', [_c('g', {
	    ref: "scene"
	  })])])
	},staticRenderFns: []}

/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "drop-click-container"
	  }, [_c('span', {
	    staticClass: "drop-click-name",
	    class: {
	      hover: _vm.hover
	    },
	    attrs: {
	      "title": _vm.selectedName
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.selectedName) + "\n    "), _c('div', {
	    staticClass: "button-dropdown"
	  }, [_vm._v(" ")])]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedInternal),
	      expression: "selectedInternal"
	    }],
	    staticClass: "back-dropdown",
	    on: {
	      "mouseenter": function($event) {
	        _vm.triggerMouseEnter(true)
	      },
	      "mouseleave": function($event) {
	        _vm.triggerMouseEnter(false)
	      },
	      "focus": function($event) {
	        _vm.triggerMouseEnter(true)
	      },
	      "blur": function($event) {
	        _vm.triggerMouseEnter(false)
	      },
	      "change": function($event) {
	        _vm.selectedInternal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_vm._l((_vm.items), function(item) {
	    return _vm._t("item", null, {
	      item: item
	    })
	  })], 2)])
	},staticRenderFns: []}

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('words-cloud-renderer'), _vm._v(" "), _c('a', {
	    staticClass: "about",
	    attrs: {
	      "href": "https://github.com/anvaka/common-words",
	      "title": "about this website..."
	    }
	  }, [_vm._v("?")]), _vm._v(" "), _c('div', {
	    staticClass: "language-picker no-print",
	    class: {
	      "list-expanded": _vm.listState.expanded
	    }
	  }, [_c('div', {
	    staticClass: "header no-select",
	    class: {
	      "context-visible": _vm.isContextVisible
	    },
	    on: {
	      "click": _vm.toggleList
	    }
	  }, [_vm._v("\n    Most used words in\n    "), _c('drop-click', {
	    attrs: {
	      "selected": _vm.languages.selected,
	      "items": _vm.languages.list
	    },
	    on: {
	      "selected": _vm.updateSelectedLanguage
	    },
	    scopedSlots: {
	      "item": function(props) {
	        return [_c('option', {
	          domProps: {
	            "value": props.item.extension
	          }
	        }, [_vm._v(_vm._s(props.item.text))])]
	      }
	    }
	  }), _vm._v(" files\n    ")], 1), _vm._v(" "), _c('div', {
	    staticClass: "word-list"
	  }, [_c('div', {
	    staticClass: "all-words list",
	    class: {
	      "context-visible": _vm.isContextVisible
	    }
	  }, _vm._l((_vm.allWords), function(word) {
	    return _c('a', {
	      staticClass: "line",
	      attrs: {
	        "href": "#",
	        "title": word.text
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.selectWord(word.text)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "place"
	    }, [_vm._v(_vm._s(word.place))]), _vm._v(" "), _c('div', {
	      staticClass: "word"
	    }, [_vm._v(_vm._s(word.text))]), _vm._v(" "), _c('div', {
	      staticClass: "count",
	      attrs: {
	        "align": "right"
	      }
	    }, [_vm._v(_vm._s(word.total))])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "context",
	    class: {
	      "context-visible": _vm.isContextVisible
	    }
	  }, [_c('div', {
	    staticClass: "context-header"
	  }, [_c('a', {
	    staticClass: "back-to-all",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.closeContext($event)
	      }
	    }
	  }, [_vm._v("all → ")]), _vm._v(" "), _c('a', {
	    staticClass: "context-word",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleList($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.sideBar.header))])]), _vm._v(" "), _c('div', {
	    staticClass: "list"
	  }, _vm._l((_vm.sideBar.lines), function(line) {
	    return _c('div', {
	      staticClass: "line"
	    }, [_c('div', {
	      staticClass: "parts",
	      attrs: {
	        "title": line.text
	      }
	    }, _vm._l((line.parts), function(part) {
	      return _c('span', {
	        class: {
	          highlight: part.bold
	        }
	      }, [_vm._v(_vm._s(part.text))])
	    })), _vm._v(" "), _c('div', {
	      staticClass: "count"
	    }, [_vm._v(_vm._s(line.count))])])
	  }))])]), _vm._v(" "), _c('a', {
	    staticClass: "expand-list context-action",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleList($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.listState.expanded ? 'hide list' : 'show list'))])])], 1)
	},staticRenderFns: []}

/***/ },
/* 125 */,
/* 126 */,
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * Allows to drag and zoom svg elements
	 */
	var wheel = __webpack_require__(136);
	var animate = __webpack_require__(133);
	var eventify = __webpack_require__(135);
	var kinetic = __webpack_require__(128);
	var createTextSelectionInterceptor = __webpack_require__(131);
	var domTextSelectionInterceptor = createTextSelectionInterceptor();
	var fakeTextSelectorInterceptor = createTextSelectionInterceptor(true);
	var Transform = __webpack_require__(132);
	var makeSvgController = __webpack_require__(130);
	var makeDomController = __webpack_require__(129);
	
	var defaultZoomSpeed = 1;
	var defaultDoubleTapZoomSpeed = 1.75;
	var doubleTapSpeedInMS = 300;
	var clickEventTimeInMS = 200;
	
	module.exports = createPanZoom;
	
	/**
	 * Creates a new instance of panzoom, so that an object can be panned and zoomed
	 *
	 * @param {DOMElement} domElement where panzoom should be attached.
	 * @param {Object} options that configure behavior.
	 */
	function createPanZoom(domElement, options) {
	  options = options || {};
	
	  var panController = options.controller;
	
	  if (!panController) {
	    if (makeSvgController.canAttach(domElement)) {
	      panController = makeSvgController(domElement, options);
	    } else if (makeDomController.canAttach(domElement)) {
	      panController = makeDomController(domElement, options);
	    }
	  }
	
	  if (!panController) {
	    throw new Error(
	      'Cannot create panzoom for the current type of dom element'
	    );
	  }
	  var owner = panController.getOwner();
	  // just to avoid GC pressure, every time we do intermediate transform
	  // we return this object. For internal use only. Never give it back to the consumer of this library
	  var storedCTMResult = { x: 0, y: 0 };
	
	  var isDirty = false;
	  var transform = new Transform();
	
	  if (panController.initTransform) {
	    panController.initTransform(transform);
	  }
	
	  var filterKey = typeof options.filterKey === 'function' ? options.filterKey : noop;
	  // TODO: likely need to unite pinchSpeed with zoomSpeed
	  var pinchSpeed = typeof options.pinchSpeed === 'number' ? options.pinchSpeed : 1;
	  var bounds = options.bounds;
	  var maxZoom = typeof options.maxZoom === 'number' ? options.maxZoom : Number.POSITIVE_INFINITY;
	  var minZoom = typeof options.minZoom === 'number' ? options.minZoom : 0;
	
	  var boundsPadding = typeof options.boundsPadding === 'number' ? options.boundsPadding : 0.05;
	  var zoomDoubleClickSpeed = typeof options.zoomDoubleClickSpeed === 'number' ? options.zoomDoubleClickSpeed : defaultDoubleTapZoomSpeed;
	  var beforeWheel = options.beforeWheel || noop;
	  var beforeMouseDown = options.beforeMouseDown || noop;
	  var speed = typeof options.zoomSpeed === 'number' ? options.zoomSpeed : defaultZoomSpeed;
	  var transformOrigin = parseTransformOrigin(options.transformOrigin);
	  var textSelection = options.enableTextSelection ? fakeTextSelectorInterceptor : domTextSelectionInterceptor;
	
	  validateBounds(bounds);
	
	  if (options.autocenter) {
	    autocenter();
	  }
	
	  var frameAnimation;
	  var lastTouchEndTime = 0;
	  var lastTouchStartTime = 0;
	  var pendingClickEventTimeout = 0;
	  var lastMouseDownedEvent = null;
	  var lastMouseDownTime = new Date();
	  var lastSingleFingerOffset;
	  var touchInProgress = false;
	
	  // We only need to fire panstart when actual move happens
	  var panstartFired = false;
	
	  // cache mouse coordinates here
	  var mouseX;
	  var mouseY;
	
	  // Where the first click has happened, so that we can differentiate
	  // between pan and click
	  var clickX;
	  var clickY;
	
	  var pinchZoomLength;
	
	  var smoothScroll;
	  if ('smoothScroll' in options && !options.smoothScroll) {
	    // If user explicitly asked us not to use smooth scrolling, we obey
	    smoothScroll = rigidScroll();
	  } else {
	    // otherwise we use forward smoothScroll settings to kinetic API
	    // which makes scroll smoothing.
	    smoothScroll = kinetic(getPoint, scroll, options.smoothScroll);
	  }
	
	  var moveByAnimation;
	  var zoomToAnimation;
	
	  var multiTouch;
	  var paused = false;
	
	  listenForEvents();
	
	  var api = {
	    dispose: dispose,
	    moveBy: internalMoveBy,
	    moveTo: moveTo,
	    smoothMoveTo: smoothMoveTo, 
	    centerOn: centerOn,
	    zoomTo: publicZoomTo,
	    zoomAbs: zoomAbs,
	    smoothZoom: smoothZoom,
	    smoothZoomAbs: smoothZoomAbs,
	    showRectangle: showRectangle,
	
	    pause: pause,
	    resume: resume,
	    isPaused: isPaused,
	
	    getTransform: getTransformModel,
	
	    getMinZoom: getMinZoom,
	    setMinZoom: setMinZoom,
	
	    getMaxZoom: getMaxZoom,
	    setMaxZoom: setMaxZoom,
	
	    getTransformOrigin: getTransformOrigin,
	    setTransformOrigin: setTransformOrigin,
	
	    getZoomSpeed: getZoomSpeed,
	    setZoomSpeed: setZoomSpeed
	  };
	
	  eventify(api);
	  
	  var initialX = typeof options.initialX === 'number' ? options.initialX : transform.x;
	  var initialY = typeof options.initialY === 'number' ? options.initialY : transform.y;
	  var initialZoom = typeof options.initialZoom === 'number' ? options.initialZoom : transform.scale;
	
	  if(initialX != transform.x || initialY != transform.y || initialZoom != transform.scale){
	    zoomAbs(initialX, initialY, initialZoom);
	  }
	
	  return api;
	
	  function pause() {
	    releaseEvents();
	    paused = true;
	  }
	
	  function resume() {
	    if (paused) {
	      listenForEvents();
	      paused = false;
	    }
	  }
	
	  function isPaused() {
	    return paused;
	  }
	
	  function showRectangle(rect) {
	    // TODO: this duplicates autocenter. I think autocenter should go.
	    var clientRect = owner.getBoundingClientRect();
	    var size = transformToScreen(clientRect.width, clientRect.height);
	
	    var rectWidth = rect.right - rect.left;
	    var rectHeight = rect.bottom - rect.top;
	    if (!Number.isFinite(rectWidth) || !Number.isFinite(rectHeight)) {
	      throw new Error('Invalid rectangle');
	    }
	
	    var dw = size.x / rectWidth;
	    var dh = size.y / rectHeight;
	    var scale = Math.min(dw, dh);
	    transform.x = -(rect.left + rectWidth / 2) * scale + size.x / 2;
	    transform.y = -(rect.top + rectHeight / 2) * scale + size.y / 2;
	    transform.scale = scale;
	  }
	
	  function transformToScreen(x, y) {
	    if (panController.getScreenCTM) {
	      var parentCTM = panController.getScreenCTM();
	      var parentScaleX = parentCTM.a;
	      var parentScaleY = parentCTM.d;
	      var parentOffsetX = parentCTM.e;
	      var parentOffsetY = parentCTM.f;
	      storedCTMResult.x = x * parentScaleX - parentOffsetX;
	      storedCTMResult.y = y * parentScaleY - parentOffsetY;
	    } else {
	      storedCTMResult.x = x;
	      storedCTMResult.y = y;
	    }
	
	    return storedCTMResult;
	  }
	
	  function autocenter() {
	    var w; // width of the parent
	    var h; // height of the parent
	    var left = 0;
	    var top = 0;
	    var sceneBoundingBox = getBoundingBox();
	    if (sceneBoundingBox) {
	      // If we have bounding box - use it.
	      left = sceneBoundingBox.left;
	      top = sceneBoundingBox.top;
	      w = sceneBoundingBox.right - sceneBoundingBox.left;
	      h = sceneBoundingBox.bottom - sceneBoundingBox.top;
	    } else {
	      // otherwise just use whatever space we have
	      var ownerRect = owner.getBoundingClientRect();
	      w = ownerRect.width;
	      h = ownerRect.height;
	    }
	    var bbox = panController.getBBox();
	    if (bbox.width === 0 || bbox.height === 0) {
	      // we probably do not have any elements in the SVG
	      // just bail out;
	      return;
	    }
	    var dh = h / bbox.height;
	    var dw = w / bbox.width;
	    var scale = Math.min(dw, dh);
	    transform.x = -(bbox.left + bbox.width / 2) * scale + w / 2 + left;
	    transform.y = -(bbox.top + bbox.height / 2) * scale + h / 2 + top;
	    transform.scale = scale;
	  }
	
	  function getTransformModel() {
	    // TODO: should this be read only?
	    return transform;
	  }
	
	  function getMinZoom() {
	    return minZoom;
	  }
	
	  function setMinZoom(newMinZoom) {
	    minZoom = newMinZoom;
	  }
	
	  function getMaxZoom() {
	    return maxZoom;
	  }
	
	  function setMaxZoom(newMaxZoom) {
	    maxZoom = newMaxZoom;
	  }
	
	  function getTransformOrigin() {
	    return transformOrigin;
	  }
	
	  function setTransformOrigin(newTransformOrigin) {
	    transformOrigin = parseTransformOrigin(newTransformOrigin);
	  }
	
	  function getZoomSpeed() {
	    return speed;
	  }
	
	  function setZoomSpeed(newSpeed) {
	    if (!Number.isFinite(newSpeed)) {
	      throw new Error('Zoom speed should be a number');
	    }
	    speed = newSpeed;
	  }
	
	  function getPoint() {
	    return {
	      x: transform.x,
	      y: transform.y
	    };
	  }
	
	  function moveTo(x, y) {
	    transform.x = x;
	    transform.y = y;
	
	    keepTransformInsideBounds();
	
	    triggerEvent('pan');
	    makeDirty();
	  }
	
	  function moveBy(dx, dy) {
	    moveTo(transform.x + dx, transform.y + dy);
	  }
	
	  function keepTransformInsideBounds() {
	    var boundingBox = getBoundingBox();
	    if (!boundingBox) return;
	
	    var adjusted = false;
	    var clientRect = getClientRect();
	
	    var diff = boundingBox.left - clientRect.right;
	    if (diff > 0) {
	      transform.x += diff;
	      adjusted = true;
	    }
	    // check the other side:
	    diff = boundingBox.right - clientRect.left;
	    if (diff < 0) {
	      transform.x += diff;
	      adjusted = true;
	    }
	
	    // y axis:
	    diff = boundingBox.top - clientRect.bottom;
	    if (diff > 0) {
	      // we adjust transform, so that it matches exactly our bounding box:
	      // transform.y = boundingBox.top - (boundingBox.height + boundingBox.y) * transform.scale =>
	      // transform.y = boundingBox.top - (clientRect.bottom - transform.y) =>
	      // transform.y = diff + transform.y =>
	      transform.y += diff;
	      adjusted = true;
	    }
	
	    diff = boundingBox.bottom - clientRect.top;
	    if (diff < 0) {
	      transform.y += diff;
	      adjusted = true;
	    }
	    return adjusted;
	  }
	
	  /**
	   * Returns bounding box that should be used to restrict scene movement.
	   */
	  function getBoundingBox() {
	    if (!bounds) return; // client does not want to restrict movement
	
	    if (typeof bounds === 'boolean') {
	      // for boolean type we use parent container bounds
	      var ownerRect = owner.getBoundingClientRect();
	      var sceneWidth = ownerRect.width;
	      var sceneHeight = ownerRect.height;
	
	      return {
	        left: sceneWidth * boundsPadding,
	        top: sceneHeight * boundsPadding,
	        right: sceneWidth * (1 - boundsPadding),
	        bottom: sceneHeight * (1 - boundsPadding)
	      };
	    }
	
	    return bounds;
	  }
	
	  function getClientRect() {
	    var bbox = panController.getBBox();
	    var leftTop = client(bbox.left, bbox.top);
	
	    return {
	      left: leftTop.x,
	      top: leftTop.y,
	      right: bbox.width * transform.scale + leftTop.x,
	      bottom: bbox.height * transform.scale + leftTop.y
	    };
	  }
	
	  function client(x, y) {
	    return {
	      x: x * transform.scale + transform.x,
	      y: y * transform.scale + transform.y
	    };
	  }
	
	  function makeDirty() {
	    isDirty = true;
	    frameAnimation = window.requestAnimationFrame(frame);
	  }
	
	  function zoomByRatio(clientX, clientY, ratio) {
	    if (isNaN(clientX) || isNaN(clientY) || isNaN(ratio)) {
	      throw new Error('zoom requires valid numbers');
	    }
	
	    var newScale = transform.scale * ratio;
	
	    if (newScale < minZoom) {
	      if (transform.scale === minZoom) return;
	
	      ratio = minZoom / transform.scale;
	    }
	    if (newScale > maxZoom) {
	      if (transform.scale === maxZoom) return;
	
	      ratio = maxZoom / transform.scale;
	    }
	
	    var size = transformToScreen(clientX, clientY);
	
	    transform.x = size.x - ratio * (size.x - transform.x);
	    transform.y = size.y - ratio * (size.y - transform.y);
	
	    // TODO: https://github.com/anvaka/panzoom/issues/112
	    if (bounds && boundsPadding === 1 && minZoom === 1) {
	      transform.scale *= ratio;
	      keepTransformInsideBounds();
	    } else {
	      var transformAdjusted = keepTransformInsideBounds();
	      if (!transformAdjusted) transform.scale *= ratio;
	    }
	
	    triggerEvent('zoom');
	
	    makeDirty();
	  }
	
	  function zoomAbs(clientX, clientY, zoomLevel) {
	    var ratio = zoomLevel / transform.scale;
	    zoomByRatio(clientX, clientY, ratio);
	  }
	
	  function centerOn(ui) {
	    var parent = ui.ownerSVGElement;
	    if (!parent)
	      throw new Error('ui element is required to be within the scene');
	
	    // TODO: should i use controller's screen CTM?
	    var clientRect = ui.getBoundingClientRect();
	    var cx = clientRect.left + clientRect.width / 2;
	    var cy = clientRect.top + clientRect.height / 2;
	
	    var container = parent.getBoundingClientRect();
	    var dx = container.width / 2 - cx;
	    var dy = container.height / 2 - cy;
	
	    internalMoveBy(dx, dy, true);
	  }
	
	  function smoothMoveTo(x, y){
	    internalMoveBy(x - transform.x, y - transform.y, true);
	  }
	
	  function internalMoveBy(dx, dy, smooth) {
	    if (!smooth) {
	      return moveBy(dx, dy);
	    }
	
	    if (moveByAnimation) moveByAnimation.cancel();
	
	    var from = { x: 0, y: 0 };
	    var to = { x: dx, y: dy };
	    var lastX = 0;
	    var lastY = 0;
	
	    moveByAnimation = animate(from, to, {
	      step: function (v) {
	        moveBy(v.x - lastX, v.y - lastY);
	
	        lastX = v.x;
	        lastY = v.y;
	      }
	    });
	  }
	
	  function scroll(x, y) {
	    cancelZoomAnimation();
	    moveTo(x, y);
	  }
	
	  function dispose() {
	    releaseEvents();
	  }
	
	  function listenForEvents() {
	    owner.addEventListener('mousedown', onMouseDown, { passive: false });
	    owner.addEventListener('dblclick', onDoubleClick, { passive: false });
	    owner.addEventListener('touchstart', onTouch, { passive: false });
	    owner.addEventListener('keydown', onKeyDown, { passive: false });
	
	    // Need to listen on the owner container, so that we are not limited
	    // by the size of the scrollable domElement
	    wheel.addWheelListener(owner, onMouseWheel, { passive: false });
	
	    makeDirty();
	  }
	
	  function releaseEvents() {
	    wheel.removeWheelListener(owner, onMouseWheel);
	    owner.removeEventListener('mousedown', onMouseDown);
	    owner.removeEventListener('keydown', onKeyDown);
	    owner.removeEventListener('dblclick', onDoubleClick);
	    owner.removeEventListener('touchstart', onTouch);
	
	    if (frameAnimation) {
	      window.cancelAnimationFrame(frameAnimation);
	      frameAnimation = 0;
	    }
	
	    smoothScroll.cancel();
	
	    releaseDocumentMouse();
	    releaseTouches();
	    textSelection.release();
	
	    triggerPanEnd();
	  }
	
	  function frame() {
	    if (isDirty) applyTransform();
	  }
	
	  function applyTransform() {
	    isDirty = false;
	
	    // TODO: Should I allow to cancel this?
	    panController.applyTransform(transform);
	
	    triggerEvent('transform');
	    frameAnimation = 0;
	  }
	
	  function onKeyDown(e) {
	    var x = 0,
	      y = 0,
	      z = 0;
	    if (e.keyCode === 38) {
	      y = 1; // up
	    } else if (e.keyCode === 40) {
	      y = -1; // down
	    } else if (e.keyCode === 37) {
	      x = 1; // left
	    } else if (e.keyCode === 39) {
	      x = -1; // right
	    } else if (e.keyCode === 189 || e.keyCode === 109) {
	      // DASH or SUBTRACT
	      z = 1; // `-` -  zoom out
	    } else if (e.keyCode === 187 || e.keyCode === 107) {
	      // EQUAL SIGN or ADD
	      z = -1; // `=` - zoom in (equal sign on US layout is under `+`)
	    }
	
	    if (filterKey(e, x, y, z)) {
	      // They don't want us to handle the key: https://github.com/anvaka/panzoom/issues/45
	      return;
	    }
	
	    if (x || y) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      var clientRect = owner.getBoundingClientRect();
	      // movement speed should be the same in both X and Y direction:
	      var offset = Math.min(clientRect.width, clientRect.height);
	      var moveSpeedRatio = 0.05;
	      var dx = offset * moveSpeedRatio * x;
	      var dy = offset * moveSpeedRatio * y;
	
	      // TODO: currently we do not animate this. It could be better to have animation
	      internalMoveBy(dx, dy);
	    }
	
	    if (z) {
	      var scaleMultiplier = getScaleMultiplier(z * 100);
	      var offset = transformOrigin ? getTransformOriginOffset() : midPoint();
	      publicZoomTo(offset.x, offset.y, scaleMultiplier);
	    }
	  }
	
	  function midPoint() {
	    var ownerRect = owner.getBoundingClientRect();
	    return {
	      x: ownerRect.width / 2,
	      y: ownerRect.height / 2
	    };
	  }
	
	  function onTouch(e) {
	    // let them override the touch behavior
	    beforeTouch(e);
	    clearPendingClickEventTimeout();
	
	    if (e.touches.length === 1) {
	      return handleSingleFingerTouch(e, e.touches[0]);
	    } else if (e.touches.length === 2) {
	      // handleTouchMove() will care about pinch zoom.
	      pinchZoomLength = getPinchZoomLength(e.touches[0], e.touches[1]);
	      multiTouch = true;
	      startTouchListenerIfNeeded();
	    }
	  }
	
	  function beforeTouch(e) {
	    // TODO: Need to unify this filtering names. E.g. use `beforeTouch`
	    if (options.onTouch && !options.onTouch(e)) {
	      // if they return `false` from onTouch, we don't want to stop
	      // events propagation. Fixes https://github.com/anvaka/panzoom/issues/12
	      return;
	    }
	
	    e.stopPropagation();
	    e.preventDefault();
	  }
	
	  function beforeDoubleClick(e) {
	    clearPendingClickEventTimeout();
	
	    // TODO: Need to unify this filtering names. E.g. use `beforeDoubleClick``
	    if (options.onDoubleClick && !options.onDoubleClick(e)) {
	      // if they return `false` from onTouch, we don't want to stop
	      // events propagation. Fixes https://github.com/anvaka/panzoom/issues/46
	      return;
	    }
	
	    e.preventDefault();
	    e.stopPropagation();
	  }
	
	  function handleSingleFingerTouch(e) {
	    lastTouchStartTime = new Date();
	    var touch = e.touches[0];
	    var offset = getOffsetXY(touch);
	    lastSingleFingerOffset = offset;
	    var point = transformToScreen(offset.x, offset.y);
	    mouseX = point.x;
	    mouseY = point.y;
	    clickX = mouseX;
	    clickY = mouseY;
	
	    smoothScroll.cancel();
	    startTouchListenerIfNeeded();
	  }
	
	  function startTouchListenerIfNeeded() {
	    if (touchInProgress) {
	      // no need to do anything, as we already listen to events;
	      return;
	    }
	
	    touchInProgress = true;
	    document.addEventListener('touchmove', handleTouchMove);
	    document.addEventListener('touchend', handleTouchEnd);
	    document.addEventListener('touchcancel', handleTouchEnd);
	  }
	
	  function handleTouchMove(e) {
	    if (e.touches.length === 1) {
	      e.stopPropagation();
	      var touch = e.touches[0];
	
	      var offset = getOffsetXY(touch);
	      var point = transformToScreen(offset.x, offset.y);
	
	      var dx = point.x - mouseX;
	      var dy = point.y - mouseY;
	
	      if (dx !== 0 && dy !== 0) {
	        triggerPanStart();
	      }
	      mouseX = point.x;
	      mouseY = point.y;
	      internalMoveBy(dx, dy);
	    } else if (e.touches.length === 2) {
	      // it's a zoom, let's find direction
	      multiTouch = true;
	      var t1 = e.touches[0];
	      var t2 = e.touches[1];
	      var currentPinchLength = getPinchZoomLength(t1, t2);
	
	      // since the zoom speed is always based on distance from 1, we need to apply
	      // pinch speed only on that distance from 1:
	      var scaleMultiplier =
	        1 + (currentPinchLength / pinchZoomLength - 1) * pinchSpeed;
	
	      var firstTouchPoint = getOffsetXY(t1);
	      var secondTouchPoint = getOffsetXY(t2);
	      mouseX = (firstTouchPoint.x + secondTouchPoint.x) / 2;
	      mouseY = (firstTouchPoint.y + secondTouchPoint.y) / 2;
	      if (transformOrigin) {
	        var offset = getTransformOriginOffset();
	        mouseX = offset.x;
	        mouseY = offset.y;
	      }
	
	      publicZoomTo(mouseX, mouseY, scaleMultiplier);
	
	      pinchZoomLength = currentPinchLength;
	      e.stopPropagation();
	      e.preventDefault();
	    }
	  }
	
	  function clearPendingClickEventTimeout() {
	    if (pendingClickEventTimeout) {
	      clearTimeout(pendingClickEventTimeout);
	      pendingClickEventTimeout = 0;
	    }
	  }
	
	  function handlePotentialClickEvent(e) {
	    // we could still be in the double tap mode, let's wait until double tap expires,
	    // and then notify:
	    if (!options.onClick) return;
	    clearPendingClickEventTimeout();
	    var dx = mouseX - clickX;
	    var dy = mouseY - clickY;
	    var l = Math.sqrt(dx * dx + dy * dy);
	    if (l > 5) return; // probably they are panning, ignore it
	
	    pendingClickEventTimeout = setTimeout(function() {
	      pendingClickEventTimeout = 0;
	      options.onClick(e);
	    }, doubleTapSpeedInMS);
	  }
	
	  function handleTouchEnd(e) {
	    clearPendingClickEventTimeout();
	    if (e.touches.length > 0) {
	      var offset = getOffsetXY(e.touches[0]);
	      var point = transformToScreen(offset.x, offset.y);
	      mouseX = point.x;
	      mouseY = point.y;
	    } else {
	      var now = new Date();
	      if (now - lastTouchEndTime < doubleTapSpeedInMS) {
	        // They did a double tap here
	        if (transformOrigin) {
	          var offset = getTransformOriginOffset();
	          smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
	        } else {
	          // We want untransformed x/y here.
	          smoothZoom(lastSingleFingerOffset.x, lastSingleFingerOffset.y, zoomDoubleClickSpeed);
	        }
	      } else if (now - lastTouchStartTime < clickEventTimeInMS) {
	        handlePotentialClickEvent(e);
	      }
	
	      lastTouchEndTime = now;
	
	      triggerPanEnd();
	      releaseTouches();
	    }
	  }
	
	  function getPinchZoomLength(finger1, finger2) {
	    var dx = finger1.clientX - finger2.clientX;
	    var dy = finger1.clientY - finger2.clientY;
	    return Math.sqrt(dx * dx + dy * dy);
	  }
	
	  function onDoubleClick(e) {
	    beforeDoubleClick(e);
	    var offset = getOffsetXY(e);
	    if (transformOrigin) {
	      // TODO: looks like this is duplicated in the file.
	      // Need to refactor
	      offset = getTransformOriginOffset();
	    }
	    smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
	  }
	
	  function onMouseDown(e) {
	    clearPendingClickEventTimeout();
	
	    // if client does not want to handle this event - just ignore the call
	    if (beforeMouseDown(e)) return;
	
	    lastMouseDownedEvent = e;
	    lastMouseDownTime = new Date();
	
	    if (touchInProgress) {
	      // modern browsers will fire mousedown for touch events too
	      // we do not want this: touch is handled separately.
	      e.stopPropagation();
	      return false;
	    }
	    // for IE, left click == 1
	    // for Firefox, left click == 0
	    var isLeftButton =
	      (e.button === 1 && window.event !== null) || e.button === 0;
	    if (!isLeftButton) return;
	
	    smoothScroll.cancel();
	
	    var offset = getOffsetXY(e);
	    var point = transformToScreen(offset.x, offset.y);
	    clickX = mouseX = point.x;
	    clickY = mouseY = point.y;
	
	    // We need to listen on document itself, since mouse can go outside of the
	    // window, and we will loose it
	    document.addEventListener('mousemove', onMouseMove);
	    document.addEventListener('mouseup', onMouseUp);
	    textSelection.capture(e.target || e.srcElement);
	
	    return false;
	  }
	
	  function onMouseMove(e) {
	    // no need to worry about mouse events when touch is happening
	    if (touchInProgress) return;
	
	    triggerPanStart();
	
	    var offset = getOffsetXY(e);
	    var point = transformToScreen(offset.x, offset.y);
	    var dx = point.x - mouseX;
	    var dy = point.y - mouseY;
	
	    mouseX = point.x;
	    mouseY = point.y;
	
	    internalMoveBy(dx, dy);
	  }
	
	  function onMouseUp() {
	    var now = new Date();
	    if (now - lastMouseDownTime < clickEventTimeInMS) handlePotentialClickEvent(lastMouseDownedEvent);
	    textSelection.release();
	    triggerPanEnd();
	    releaseDocumentMouse();
	  }
	
	  function releaseDocumentMouse() {
	    document.removeEventListener('mousemove', onMouseMove);
	    document.removeEventListener('mouseup', onMouseUp);
	    panstartFired = false;
	  }
	
	  function releaseTouches() {
	    document.removeEventListener('touchmove', handleTouchMove);
	    document.removeEventListener('touchend', handleTouchEnd);
	    document.removeEventListener('touchcancel', handleTouchEnd);
	    panstartFired = false;
	    multiTouch = false;
	    touchInProgress = false;
	  }
	
	  function onMouseWheel(e) {
	    // if client does not want to handle this event - just ignore the call
	    if (beforeWheel(e)) return;
	
	    smoothScroll.cancel();
	
	    var delta = e.deltaY;
	    if (e.deltaMode > 0) delta *= 100;
	
	    var scaleMultiplier = getScaleMultiplier(delta);
	
	    if (scaleMultiplier !== 1) {
	      var offset = transformOrigin
	        ? getTransformOriginOffset()
	        : getOffsetXY(e);
	      publicZoomTo(offset.x, offset.y, scaleMultiplier);
	      e.preventDefault();
	    }
	  }
	
	  function getOffsetXY(e) {
	    var offsetX, offsetY;
	    // I tried using e.offsetX, but that gives wrong results for svg, when user clicks on a path.
	    var ownerRect = owner.getBoundingClientRect();
	    offsetX = e.clientX - ownerRect.left;
	    offsetY = e.clientY - ownerRect.top;
	
	    return { x: offsetX, y: offsetY };
	  }
	
	  function smoothZoom(clientX, clientY, scaleMultiplier) {
	    var fromValue = transform.scale;
	    var from = { scale: fromValue };
	    var to = { scale: scaleMultiplier * fromValue };
	
	    smoothScroll.cancel();
	    cancelZoomAnimation();
	
	    zoomToAnimation = animate(from, to, {
	      step: function (v) {
	        zoomAbs(clientX, clientY, v.scale);
	      },
	      done: triggerZoomEnd
	    });
	  }
	
	  function smoothZoomAbs(clientX, clientY, toScaleValue) {
	    var fromValue = transform.scale;
	    var from = { scale: fromValue };
	    var to = { scale: toScaleValue };
	
	    smoothScroll.cancel();
	    cancelZoomAnimation();
	
	    zoomToAnimation = animate(from, to, {
	      step: function (v) {
	        zoomAbs(clientX, clientY, v.scale);
	      }
	    });
	  }
	
	  function getTransformOriginOffset() {
	    var ownerRect = owner.getBoundingClientRect();
	    return {
	      x: ownerRect.width * transformOrigin.x,
	      y: ownerRect.height * transformOrigin.y
	    };
	  }
	
	  function publicZoomTo(clientX, clientY, scaleMultiplier) {
	    smoothScroll.cancel();
	    cancelZoomAnimation();
	    return zoomByRatio(clientX, clientY, scaleMultiplier);
	  }
	
	  function cancelZoomAnimation() {
	    if (zoomToAnimation) {
	      zoomToAnimation.cancel();
	      zoomToAnimation = null;
	    }
	  }
	
	  function getScaleMultiplier(delta) {
	    var sign = Math.sign(delta);
	    var deltaAdjustedSpeed = Math.min(0.25, Math.abs(speed * delta / 128));
	    return 1 - sign * deltaAdjustedSpeed;
	  }
	
	  function triggerPanStart() {
	    if (!panstartFired) {
	      triggerEvent('panstart');
	      panstartFired = true;
	      smoothScroll.start();
	    }
	  }
	
	  function triggerPanEnd() {
	    if (panstartFired) {
	      // we should never run smooth scrolling if it was multiTouch (pinch zoom animation):
	      if (!multiTouch) smoothScroll.stop();
	      triggerEvent('panend');
	    }
	  }
	
	  function triggerZoomEnd() {
	    triggerEvent('zoomend');
	  }
	
	  function triggerEvent(name) {
	    api.fire(name, api);
	  }
	}
	
	function parseTransformOrigin(options) {
	  if (!options) return;
	  if (typeof options === 'object') {
	    if (!isNumber(options.x) || !isNumber(options.y))
	      failTransformOrigin(options);
	    return options;
	  }
	
	  failTransformOrigin();
	}
	
	function failTransformOrigin(options) {
	  console.error(options);
	  throw new Error(
	    [
	      'Cannot parse transform origin.',
	      'Some good examples:',
	      '  "center center" can be achieved with {x: 0.5, y: 0.5}',
	      '  "top center" can be achieved with {x: 0.5, y: 0}',
	      '  "bottom right" can be achieved with {x: 1, y: 1}'
	    ].join('\n')
	  );
	}
	
	function noop() { }
	
	function validateBounds(bounds) {
	  var boundsType = typeof bounds;
	  if (boundsType === 'undefined' || boundsType === 'boolean') return; // this is okay
	  // otherwise need to be more thorough:
	  var validBounds =
	    isNumber(bounds.left) &&
	    isNumber(bounds.top) &&
	    isNumber(bounds.bottom) &&
	    isNumber(bounds.right);
	
	  if (!validBounds)
	    throw new Error(
	      'Bounds object is not valid. It can be: ' +
	      'undefined, boolean (true|false) or an object {left, top, right, bottom}'
	    );
	}
	
	function isNumber(x) {
	  return Number.isFinite(x);
	}
	
	// IE 11 does not support isNaN:
	function isNaN(value) {
	  if (Number.isNaN) {
	    return Number.isNaN(value);
	  }
	
	  return value !== value;
	}
	
	function rigidScroll() {
	  return {
	    start: noop,
	    stop: noop,
	    cancel: noop
	  };
	}
	
	function autoRun() {
	  if (typeof document === 'undefined') return;
	
	  var scripts = document.getElementsByTagName('script');
	  if (!scripts) return;
	  var panzoomScript;
	
	  for (var i = 0; i < scripts.length; ++i) {
	    var x = scripts[i];
	    if (x.src && x.src.match(/\bpanzoom(\.min)?\.js/)) {
	      panzoomScript = x;
	      break;
	    }
	  }
	
	  if (!panzoomScript) return;
	
	  var query = panzoomScript.getAttribute('query');
	  if (!query) return;
	
	  var globalName = panzoomScript.getAttribute('name') || 'pz';
	  var started = Date.now();
	
	  tryAttach();
	
	  function tryAttach() {
	    var el = document.querySelector(query);
	    if (!el) {
	      var now = Date.now();
	      var elapsed = now - started;
	      if (elapsed < 2000) {
	        // Let's wait a bit
	        setTimeout(tryAttach, 100);
	        return;
	      }
	      // If we don't attach within 2 seconds to the target element, consider it a failure
	      console.error('Cannot find the panzoom element', globalName);
	      return;
	    }
	    var options = collectOptions(panzoomScript);
	    console.log(options);
	    window[globalName] = createPanZoom(el, options);
	  }
	
	  function collectOptions(script) {
	    var attrs = script.attributes;
	    var options = {};
	    for (var j = 0; j < attrs.length; ++j) {
	      var attr = attrs[j];
	      var nameValue = getPanzoomAttributeNameValue(attr);
	      if (nameValue) {
	        options[nameValue.name] = nameValue.value;
	      }
	    }
	
	    return options;
	  }
	
	  function getPanzoomAttributeNameValue(attr) {
	    if (!attr.name) return;
	    var isPanZoomAttribute =
	      attr.name[0] === 'p' && attr.name[1] === 'z' && attr.name[2] === '-';
	
	    if (!isPanZoomAttribute) return;
	
	    var name = attr.name.substr(3);
	    var value = JSON.parse(attr.value);
	    return { name: name, value: value };
	  }
	}
	
	autoRun();
		

/***/ },
/* 128 */
/***/ function(module, exports) {

	/**
	 * Allows smooth kinetic scrolling of the surface
	 */
	module.exports = kinetic;
	
	function kinetic(getPoint, scroll, settings) {
	  if (typeof settings !== 'object') {
	    // setting could come as boolean, we should ignore it, and use an object.
	    settings = {};
	  }
	
	  var minVelocity = typeof settings.minVelocity === 'number' ? settings.minVelocity : 5;
	  var amplitude = typeof settings.amplitude === 'number' ? settings.amplitude : 0.25;
	  var cancelAnimationFrame = typeof settings.cancelAnimationFrame === 'function' ? settings.cancelAnimationFrame : getCancelAnimationFrame();
	  var requestAnimationFrame = typeof settings.requestAnimationFrame === 'function' ? settings.requestAnimationFrame : getRequestAnimationFrame();
	
	  var lastPoint;
	  var timestamp;
	  var timeConstant = 342;
	
	  var ticker;
	  var vx, targetX, ax;
	  var vy, targetY, ay;
	
	  var raf;
	
	  return {
	    start: start,
	    stop: stop,
	    cancel: dispose
	  };
	
	  function dispose() {
	    cancelAnimationFrame(ticker);
	    cancelAnimationFrame(raf);
	  }
	
	  function start() {
	    lastPoint = getPoint();
	
	    ax = ay = vx = vy = 0;
	    timestamp = new Date();
	
	    cancelAnimationFrame(ticker);
	    cancelAnimationFrame(raf);
	
	    // we start polling the point position to accumulate velocity
	    // Once we stop(), we will use accumulated velocity to keep scrolling
	    // an object.
	    ticker = requestAnimationFrame(track);
	  }
	
	  function track() {
	    var now = Date.now();
	    var elapsed = now - timestamp;
	    timestamp = now;
	
	    var currentPoint = getPoint();
	
	    var dx = currentPoint.x - lastPoint.x;
	    var dy = currentPoint.y - lastPoint.y;
	
	    lastPoint = currentPoint;
	
	    var dt = 1000 / (1 + elapsed);
	
	    // moving average
	    vx = 0.8 * dx * dt + 0.2 * vx;
	    vy = 0.8 * dy * dt + 0.2 * vy;
	
	    ticker = requestAnimationFrame(track);
	  }
	
	  function stop() {
	    cancelAnimationFrame(ticker);
	    cancelAnimationFrame(raf);
	
	    var currentPoint = getPoint();
	
	    targetX = currentPoint.x;
	    targetY = currentPoint.y;
	    timestamp = Date.now();
	
	    if (vx < -minVelocity || vx > minVelocity) {
	      ax = amplitude * vx;
	      targetX += ax;
	    }
	
	    if (vy < -minVelocity || vy > minVelocity) {
	      ay = amplitude * vy;
	      targetY += ay;
	    }
	
	    raf = requestAnimationFrame(autoScroll);
	  }
	
	  function autoScroll() {
	    var elapsed = Date.now() - timestamp;
	
	    var moving = false;
	    var dx = 0;
	    var dy = 0;
	
	    if (ax) {
	      dx = -ax * Math.exp(-elapsed / timeConstant);
	
	      if (dx > 0.5 || dx < -0.5) moving = true;
	      else dx = ax = 0;
	    }
	
	    if (ay) {
	      dy = -ay * Math.exp(-elapsed / timeConstant);
	
	      if (dy > 0.5 || dy < -0.5) moving = true;
	      else dy = ay = 0;
	    }
	
	    if (moving) {
	      scroll(targetX + dx, targetY + dy);
	      raf = requestAnimationFrame(autoScroll);
	    }
	  }
	}
	
	function getCancelAnimationFrame() {
	  if (typeof cancelAnimationFrame === 'function') return cancelAnimationFrame;
	  return clearTimeout;
	}
	
	function getRequestAnimationFrame() {
	  if (typeof requestAnimationFrame === 'function') return requestAnimationFrame;
	
	  return function (handler) {
	    return setTimeout(handler, 16);
	  };
	}

/***/ },
/* 129 */
/***/ function(module, exports) {

	module.exports = makeDomController;
	
	module.exports.canAttach = isDomElement;
	
	function makeDomController(domElement, options) {
	  var elementValid = isDomElement(domElement); 
	  if (!elementValid) {
	    throw new Error('panzoom requires DOM element to be attached to the DOM tree');
	  }
	
	  var owner = domElement.parentElement;
	  domElement.scrollTop = 0;
	  
	  if (!options.disableKeyboardInteraction) {
	    owner.setAttribute('tabindex', 0);
	  }
	
	  var api = {
	    getBBox: getBBox,
	    getOwner: getOwner,
	    applyTransform: applyTransform,
	  };
	  
	  return api;
	
	  function getOwner() {
	    return owner;
	  }
	
	  function getBBox() {
	    // TODO: We should probably cache this?
	    return  {
	      left: 0,
	      top: 0,
	      width: domElement.clientWidth,
	      height: domElement.clientHeight
	    };
	  }
	
	  function applyTransform(transform) {
	    // TODO: Should we cache this?
	    domElement.style.transformOrigin = '0 0 0';
	    domElement.style.transform = 'matrix(' +
	      transform.scale + ', 0, 0, ' +
	      transform.scale + ', ' +
	      transform.x + ', ' + transform.y + ')';
	  }
	}
	
	function isDomElement(element) {
	  return element && element.parentElement && element.style;
	}


/***/ },
/* 130 */
/***/ function(module, exports) {

	module.exports = makeSvgController;
	module.exports.canAttach = isSVGElement;
	
	function makeSvgController(svgElement, options) {
	  if (!isSVGElement(svgElement)) {
	    throw new Error('svg element is required for svg.panzoom to work');
	  }
	
	  var owner = svgElement.ownerSVGElement;
	  if (!owner) {
	    throw new Error(
	      'Do not apply panzoom to the root <svg> element. ' +
	      'Use its child instead (e.g. <g></g>). ' +
	      'As of March 2016 only FireFox supported transform on the root element');
	  }
	
	  if (!options.disableKeyboardInteraction) {
	    owner.setAttribute('tabindex', 0);
	  }
	
	  var api = {
	    getBBox: getBBox,
	    getScreenCTM: getScreenCTM,
	    getOwner: getOwner,
	    applyTransform: applyTransform,
	    initTransform: initTransform
	  };
	  
	  return api;
	
	  function getOwner() {
	    return owner;
	  }
	
	  function getBBox() {
	    var boundingBox =  svgElement.getBBox();
	    return {
	      left: boundingBox.x,
	      top: boundingBox.y,
	      width: boundingBox.width,
	      height: boundingBox.height,
	    };
	  }
	
	  function getScreenCTM() {
	    var ctm = owner.getCTM();
	    if (!ctm) {
	      // This is likely firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=873106
	      // The code below is not entirely correct, but still better than nothing
	      return owner.getScreenCTM();
	    }
	    return ctm;
	  }
	
	  function initTransform(transform) {
	    var screenCTM = svgElement.getCTM();
	
	    // The above line returns null on Firefox
	    if (screenCTM === null) {
	      screenCTM = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix();
	    }
	
	    transform.x = screenCTM.e;
	    transform.y = screenCTM.f;
	    transform.scale = screenCTM.a;
	    owner.removeAttributeNS(null, 'viewBox');
	  }
	
	  function applyTransform(transform) {
	    svgElement.setAttribute('transform', 'matrix(' +
	      transform.scale + ' 0 0 ' +
	      transform.scale + ' ' +
	      transform.x + ' ' + transform.y + ')');
	  }
	}
	
	function isSVGElement(element) {
	  return element && element.ownerSVGElement && element.getCTM;
	}

/***/ },
/* 131 */
/***/ function(module, exports) {

	/**
	 * Disallows selecting text.
	 */
	module.exports = makeTextSelectionInterceptor;
	
	function makeTextSelectionInterceptor(useFake) {
	  if (useFake) {
	    return {
	      capture: noop,
	      release: noop
	    };
	  }
	
	  var dragObject;
	  var prevSelectStart;
	  var prevDragStart;
	  var wasCaptured = false;
	
	  return {
	    capture: capture,
	    release: release
	  };
	
	  function capture(domObject) {
	    wasCaptured = true;
	    prevSelectStart = window.document.onselectstart;
	    prevDragStart = window.document.ondragstart;
	
	    window.document.onselectstart = disabled;
	
	    dragObject = domObject;
	    dragObject.ondragstart = disabled;
	  }
	
	  function release() {
	    if (!wasCaptured) return;
	    
	    wasCaptured = false;
	    window.document.onselectstart = prevSelectStart;
	    if (dragObject) dragObject.ondragstart = prevDragStart;
	  }
	}
	
	function disabled(e) {
	  e.stopPropagation();
	  return false;
	}
	
	function noop() {}


/***/ },
/* 132 */
/***/ function(module, exports) {

	module.exports = Transform;
	
	function Transform() {
	  this.x = 0;
	  this.y = 0;
	  this.scale = 1;
	}


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var BezierEasing = __webpack_require__(134)
	
	// Predefined set of animations. Similar to CSS easing functions
	var animations = {
	  ease:  BezierEasing(0.25, 0.1, 0.25, 1),
	  easeIn: BezierEasing(0.42, 0, 1, 1),
	  easeOut: BezierEasing(0, 0, 0.58, 1),
	  easeInOut: BezierEasing(0.42, 0, 0.58, 1),
	  linear: BezierEasing(0, 0, 1, 1)
	}
	
	
	module.exports = animate;
	module.exports.makeAggregateRaf = makeAggregateRaf;
	module.exports.sharedScheduler = makeAggregateRaf();
	
	
	function animate(source, target, options) {
	  var start = Object.create(null)
	  var diff = Object.create(null)
	  options = options || {}
	  // We let clients specify their own easing function
	  var easing = (typeof options.easing === 'function') ? options.easing : animations[options.easing]
	
	  // if nothing is specified, default to ease (similar to CSS animations)
	  if (!easing) {
	    if (options.easing) {
	      console.warn('Unknown easing function in amator: ' + options.easing);
	    }
	    easing = animations.ease
	  }
	
	  var step = typeof options.step === 'function' ? options.step : noop
	  var done = typeof options.done === 'function' ? options.done : noop
	
	  var scheduler = getScheduler(options.scheduler)
	
	  var keys = Object.keys(target)
	  keys.forEach(function(key) {
	    start[key] = source[key]
	    diff[key] = target[key] - source[key]
	  })
	
	  var durationInMs = typeof options.duration === 'number' ? options.duration : 400
	  var durationInFrames = Math.max(1, durationInMs * 0.06) // 0.06 because 60 frames pers 1,000 ms
	  var previousAnimationId
	  var frame = 0
	
	  previousAnimationId = scheduler.next(loop)
	
	  return {
	    cancel: cancel
	  }
	
	  function cancel() {
	    scheduler.cancel(previousAnimationId)
	    previousAnimationId = 0
	  }
	
	  function loop() {
	    var t = easing(frame/durationInFrames)
	    frame += 1
	    setValues(t)
	    if (frame <= durationInFrames) {
	      previousAnimationId = scheduler.next(loop)
	      step(source)
	    } else {
	      previousAnimationId = 0
	      setTimeout(function() { done(source) }, 0)
	    }
	  }
	
	  function setValues(t) {
	    keys.forEach(function(key) {
	      source[key] = diff[key] * t + start[key]
	    })
	  }
	}
	
	function noop() { }
	
	function getScheduler(scheduler) {
	  if (!scheduler) {
	    var canRaf = typeof window !== 'undefined' && window.requestAnimationFrame
	    return canRaf ? rafScheduler() : timeoutScheduler()
	  }
	  if (typeof scheduler.next !== 'function') throw new Error('Scheduler is supposed to have next(cb) function')
	  if (typeof scheduler.cancel !== 'function') throw new Error('Scheduler is supposed to have cancel(handle) function')
	
	  return scheduler
	}
	
	function rafScheduler() {
	  return {
	    next: window.requestAnimationFrame.bind(window),
	    cancel: window.cancelAnimationFrame.bind(window)
	  }
	}
	
	function timeoutScheduler() {
	  return {
	    next: function(cb) {
	      return setTimeout(cb, 1000/60)
	    },
	    cancel: function (id) {
	      return clearTimeout(id)
	    }
	  }
	}
	
	function makeAggregateRaf() {
	  var frontBuffer = new Set();
	  var backBuffer = new Set();
	  var frameToken = 0;
	
	  return {
	    next: next,
	    cancel: next,
	    clearAll: clearAll
	  }
	
	  function clearAll() {
	    frontBuffer.clear();
	    backBuffer.clear();
	    cancelAnimationFrame(frameToken);
	    frameToken = 0;
	  }
	
	  function next(callback) {
	    backBuffer.add(callback);
	    renderNextFrame();
	  }
	
	  function renderNextFrame() {
	    if (!frameToken) frameToken = requestAnimationFrame(renderFrame);
	  }
	
	  function renderFrame() {
	    frameToken = 0;
	
	    var t = backBuffer;
	    backBuffer = frontBuffer;
	    frontBuffer = t;
	
	    frontBuffer.forEach(function(callback) {
	      callback();
	    });
	    frontBuffer.clear();
	  }
	
	  function cancel(callback) {
	    backBuffer.delete(callback);
	  }
	}


/***/ },
/* 134 */
/***/ function(module, exports) {

	/**
	 * https://github.com/gre/bezier-easing
	 * BezierEasing - use bezier curve for transition easing function
	 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	 */
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	var float32ArraySupported = typeof Float32Array === 'function';
	
	function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }
	
	function binarySubdivide (aX, aA, aB, mX1, mX2) {
	  var currentX, currentT, i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}
	
	function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	   var currentSlope = getSlope(aGuessT, mX1, mX2);
	   if (currentSlope === 0.0) {
	     return aGuessT;
	   }
	   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	   aGuessT -= currentX / currentSlope;
	 }
	 return aGuessT;
	}
	
	function LinearEasing (x) {
	  return x;
	}
	
	module.exports = function bezier (mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    throw new Error('bezier x values must be in [0, 1] range');
	  }
	
	  if (mX1 === mY1 && mX2 === mY2) {
	    return LinearEasing;
	  }
	
	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  for (var i = 0; i < kSplineTableSize; ++i) {
	    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	  }
	
	  function getTForX (aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;
	
	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;
	
	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;
	
	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  return function BezierEasing (x) {
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	};


/***/ },
/* 135 */
/***/ function(module, exports) {

	module.exports = function eventify(subject) {
	  validateSubject(subject);
	
	  var eventsStorage = createEventsStorage(subject);
	  subject.on = eventsStorage.on;
	  subject.off = eventsStorage.off;
	  subject.fire = eventsStorage.fire;
	  return subject;
	};
	
	function createEventsStorage(subject) {
	  // Store all event listeners to this hash. Key is event name, value is array
	  // of callback records.
	  //
	  // A callback record consists of callback function and its optional context:
	  // { 'eventName' => [{callback: function, ctx: object}] }
	  var registeredEvents = Object.create(null);
	
	  return {
	    on: function (eventName, callback, ctx) {
	      if (typeof callback !== 'function') {
	        throw new Error('callback is expected to be a function');
	      }
	      var handlers = registeredEvents[eventName];
	      if (!handlers) {
	        handlers = registeredEvents[eventName] = [];
	      }
	      handlers.push({callback: callback, ctx: ctx});
	
	      return subject;
	    },
	
	    off: function (eventName, callback) {
	      var wantToRemoveAll = (typeof eventName === 'undefined');
	      if (wantToRemoveAll) {
	        // Killing old events storage should be enough in this case:
	        registeredEvents = Object.create(null);
	        return subject;
	      }
	
	      if (registeredEvents[eventName]) {
	        var deleteAllCallbacksForEvent = (typeof callback !== 'function');
	        if (deleteAllCallbacksForEvent) {
	          delete registeredEvents[eventName];
	        } else {
	          var callbacks = registeredEvents[eventName];
	          for (var i = 0; i < callbacks.length; ++i) {
	            if (callbacks[i].callback === callback) {
	              callbacks.splice(i, 1);
	            }
	          }
	        }
	      }
	
	      return subject;
	    },
	
	    fire: function (eventName) {
	      var callbacks = registeredEvents[eventName];
	      if (!callbacks) {
	        return subject;
	      }
	
	      var fireArguments;
	      if (arguments.length > 1) {
	        fireArguments = Array.prototype.splice.call(arguments, 1);
	      }
	      for(var i = 0; i < callbacks.length; ++i) {
	        var callbackInfo = callbacks[i];
	        callbackInfo.callback.apply(callbackInfo.ctx, fireArguments);
	      }
	
	      return subject;
	    }
	  };
	}
	
	function validateSubject(subject) {
	  if (!subject) {
	    throw new Error('Eventify cannot use falsy object as events subject');
	  }
	  var reservedWords = ['on', 'fire', 'off'];
	  for (var i = 0; i < reservedWords.length; ++i) {
	    if (subject.hasOwnProperty(reservedWords[i])) {
	      throw new Error("Subject cannot be eventified, since it already has property '" + reservedWords[i] + "'");
	    }
	  }
	}


/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * This module used to unify mouse wheel behavior between different browsers in 2014
	 * Now it's just a wrapper around addEventListener('wheel');
	 *
	 * Usage:
	 *  var addWheelListener = require('wheel').addWheelListener;
	 *  var removeWheelListener = require('wheel').removeWheelListener;
	 *  addWheelListener(domElement, function (e) {
	 *    // mouse wheel event
	 *  });
	 *  removeWheelListener(domElement, function);
	 */
	
	module.exports = addWheelListener;
	
	// But also expose "advanced" api with unsubscribe:
	module.exports.addWheelListener = addWheelListener;
	module.exports.removeWheelListener = removeWheelListener;
	
	
	function addWheelListener(element, listener, useCapture) {
	  element.addEventListener('wheel', listener, useCapture);
	}
	
	function removeWheelListener( element, listener, useCapture ) {
	  element.removeEventListener('wheel', listener, useCapture);
	}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.cb1725aac1e08ba6565e.js